import Observable from '../utils/Observable'

const toggleClass = (el, className) => hasClass => el.toggleClass(className, hasClass)
const setText = el => text => el.text(text)

const updateSlider = slider => wattage => {
  slider.slick(
    'slickFilter',
    (i, el) =>
      !wattage ||
      $(el)
        .data('wattages')
        .includes(wattage)
  )
}

jQuery($ =>
  $('.xr-convert').each(function () {
    const container = $(this)

    // State
    const wattage = new Observable(false).log('wattage')
    const lumen = new Observable().log('lumen')

    // User Interaction
    const selectWattage = container.find('select.xr-convert-wattage').change(() => {
      const selected = selectWattage.find(':selected')
      wattage.set(selected.val())
      lumen.set(selected.data('lumen'))
    })

    // UI Updates
    wattage.map(x => !x).watch(toggleClass(container.find('.xr-convert__new'), 'xr-convert__new--empty'))

    lumen.watch(setText(container.find('.xr-convert-lumen-number')))

    container.find('.xr-slideshow').slick({
      dots: true,
      arrows: false,
      infinite: false,
      slidesToScroll: 1,
      slidesToShow: 1,
      mobileFirst: true,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 650,
          settings: {
            slidesToShow: 2,
            arrows: true
          }
        }
      ]
    })
    wattage.watch(updateSlider(container.find('.xr-slideshow')))
  })
)
